module.exports = __webpack_public_path__ + "img/pizza-quick-lunch.26d0f2f5.jpg";